import { AdBiddingProvider, IAdBiddingProviderConfig } from '../../../'
import { Errors } from '../../../../../../utils/common'
import { logger } from '../../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../../utils/dom'
import { AdDOM, AdRefreshDOM } from '../../../../ad'
import { AdBiddingBase } from '../base'

export interface IWindow extends Window {
    aax: any
}

declare let window: IWindow

class AAX extends AdBiddingBase {
    public static enabled = false
    public requestAdsPromise: undefined
    public adDOM = {
        class: {
            hidden: 'visually-hidden',
            hideWrapper: 'ad__section-border--hide',
            refresh: 'ad-refresh',
            wrapper: 'ad__section-border'
        }
    }
    protected URLPath: string
    protected AAXVersion = '1.2'
    protected waitForBidder = false
    protected bidderType = 'aax'

    constructor() {
        super()
        this.URLPath = '//c.aaxads.com/aax.js'
    }

    private static onAAXError() {
        window.aax.error = true

        document.dispatchEvent(new Event(Errors.AAX_ERROR))
    }

    public initializeBidding(confs: IAdBiddingProviderConfig[]): void {
        const conf = confs.find((_) => _.client === AdBiddingProvider.AAX)
        if (conf) {
            window.aax = window.aax || {}
            window.aax.cmd = window.aax.cmd || []

            const aax = window.aax
            aax.initTime = new Date().getTime()
            aax.pubId = conf.account
            aax.ver = this.AAXVersion
            aax.hst = window.location.hostname

            // load JS
            DOMUtils
                .loadScript(`${this.URLPath}?pub=${aax.pubId}&hst=${aax.hst}&ver=${aax.ver}`, [{
                    key: DOMUtils.attrs.id,
                    value: AdBiddingProvider.AAX
                }], AAX.onAAXError)

            AAX.enabled = true
            this.requestAds()
            logger(`debug`, `Initialize AAX bidder: ${this.URLPath}`)
        }
    }

    /**
     * add acceptable ad attribute to specific ads only
     */
    public initAcceptableAds() {
        DOMUtils.nodes(document.querySelectorAll(`[${AdDOM.attr.size.key}]`))
            .forEach((el: Element) => {
                if (el.hasAttribute(`${AdDOM.attr.acceptableAd.key}`)) {
                    this.addRefreshToAcceptableAd(el)
                    this.unhideAcceptableAdSlot(el)
                } else {
                    this.hideNoneAcceptableAdSlot(el)
                }
            })
    }

    /**
     * Unhide hidden acceptable ad slots
     */
    public hideNoneAcceptableAdSlot(el: Element) {
        const elem = el.closest(`.${this.adDOM.class.wrapper}`)
        if (elem) {
            elem.classList.add(`${this.adDOM.class.hideWrapper}`)
        }
    }

    /**
     * Unhide hidden acceptable ad slots
     */
    public unhideAcceptableAdSlot(el: Element) {
        const elem = el.closest(`.${this.adDOM.class.hidden}`)
        if (elem) {
            elem.classList.remove(`${this.adDOM.class.hidden}`)
        }
        el.classList.remove(`${this.adDOM.class.refresh}`)
    }

    /**
     * set refresh attribute off to acceptable ads only
     */
    public addRefreshToAcceptableAd(el: Element) {
        if (!el.hasAttribute(`${AdRefreshDOM.attr.state.key}`)) {
            el.setAttribute(AdRefreshDOM.attr.state.key, AdRefreshDOM.attr.state.value.off)
        }
    }

    /**
     * init acceptable ad if adpStatus is true
     */
    public requestAds() {
        if (AAX.enabled) {
            window.aax.cmd.push(() => {
                if (window.aax.getAbpStatus && window.aax.getAbpStatus()) {
                    this.initAcceptableAds()
                    logger('info', `AAX: ABP detect is:`, true)
                } else {
                    logger('info', `AAX: ABP detect is:`, false)
                }
            })
        }
    }
}

export default AAX
